import { render, staticRenderFns } from "./texts.vue?vue&type=template&id=630575f0&scoped=true&"
import script from "./texts.vue?vue&type=script&lang=js&"
export * from "./texts.vue?vue&type=script&lang=js&"
import style0 from "./texts.vue?vue&type=style&index=0&id=630575f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630575f0",
  null
  
)

export default component.exports